import { render } from "./categories-page.vue?vue&type=template&id=3d805637"
import script from "./categories-page.vue?vue&type=script&lang=js"
export * from "./categories-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__